export default [
  {
    path: '/',
    redirect: '/introduce'
  },
  {
    path: '/introduce',
    name: 'introduce',
    component: function (resolve) {
      require(['../views/introduce'], resolve)
    },
    meta: {
      title: '社保卡介绍'
    }
  },
  {
    path: '/home',
    name: 'home',
    component: function (resolve) {
      require(['../views/home'], resolve)
    },
    meta: {
      title: '首页'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: function (resolve) {
      require(['../views/agreement'], resolve)
    },
    meta: {
      title: '社保卡申办',
      requireAuth: true
    }
  },
  {
    path: '/review',
    name: 'review',
    component: function (resolve) {
      require(['../views/review'], resolve)
    },
    meta: {
      title: '社保卡申办',
      requireAuth: true
    }
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: function (resolve) {
      require(['../views/confirm'], resolve)
    },
    meta: {
      title: '社保卡申办',
      requireAuth: true
    }
  },
  {
    path: '/form',
    name: 'form',
    component: function (resolve) {
      require(['../views/form'], resolve)
    },
    meta: {
      title: '社保卡申办',
      requireAuth: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: function (resolve) {
      require(['../views/search'], resolve)
    },
    meta: {
      title: '社保卡申办'
    }
  },
  {
    path: '/back',
    name: 'back',
    component: function (resolve) {
      require(['../views/back'], resolve)
    },
    meta: {
      title: '撤销申请'
    }
  },
  {
    path: '/fail',
    name: 'fail',
    component: function (resolve) {
      require(['../views/fail'], resolve)
    },
    meta: {
      title: '登录失败'
    }
  },
  {
    path: '/book-success',
    name: 'book-success',
    component: function (resolve) {
      require(['../views/book-success'], resolve)
    },
    meta: {
      title: '社保卡申办',
      requireAuth: true
    }
  }
]
